import { useStaticQuery, graphql } from 'gatsby';
import { Promo } from '../utils/promo';

/**
 * Reads the single build-time promo node (DP-2225). Shared by every surface —
 * the banner + pop-up (usePromoPrompt) and the salary-sidebar card
 * (RelatedSalary) — so they all consume the same HubDB-sourced campaign.
 */
export default function usePromo(): Promo | null {
  const data = useStaticQuery<{ dentalPostPromo: Promo | null }>(graphql`
    query {
      dentalPostPromo {
        promoId
        isActive
        showBanner
        showPopup
        startDate
        endDate
        chipLabel
        modalHeading
        modalBody
        bullets
        bannerHeading
        ctaLabel
        bannerCtaUrl
        popupCtaUrl
        sidebarCtaUrl
        secondaryLabel
        frequencyDays
      }
    }
  `);
  return data.dentalPostPromo;
}
